/**
 * A TabPanel is displayed when a corresponding Tab is selected
 */
import React, { ReactNode, Component, createRef } from "react";
import { TransitionStatus } from "react-transition-group/Transition";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { TabsContext } from "./Tabs";

export interface ITabPanelProps {
  children: ReactNode;
  index?: number;
  status?: TransitionStatus;
  direction?: -1 | 1;
  className?: string;
}

class TabPanel extends Component<ITabPanelProps> {
  public static contextType = TabsContext;
  private panelRef = createRef<HTMLDivElement>();

  public componentDidMount(): void {
    this.context.setPanelRef(this.panelRef);
  }

  private handleResize = (width?: number, height?: number): void => {
    this.context.updatePanelHeight(height);
  };

  public render(): ReactNode {
    const { children, index, status, className, direction } = this.props;
    const { id } = this.context;

    return (
      <div
        className={classNames("tabs__tab-panel", `tabs__tab-panel--${status}`, className, {
          [`tabs__tab-panel--${direction === 1 ? "next" : "previous"}`]: !["entered", "entering"].includes(
            status ?? "",
          ),
        })}
        role="tabpanel"
        id={`tabs-${id}-panel-${index}`}
        aria-labelledby={`tabs-${id}-tab-${index}`}
        ref={this.panelRef}
        tabIndex={-1}
      >
        <ReactResizeDetector handleHeight onResize={this.handleResize} />
        {children}
      </div>
    );
  }
}

export default TabPanel;
